import { DateRangeFilter, FilterModal, SearchFilter } from '@synergy/components';
import { FormattedMessage } from 'react-intl';

import { ImportStatusFilter } from '../../../../common/components/filter/import-status-filter';
import { LegacySupplierFilter } from '../../../../common/components/filter/legacy-supplier-filter';
import { ResponsibleContactFilter } from '../../../../common/components/filter/responsible-contact-filter';
import { ResponsibleQuickContactFilter } from '../../../../common/components/filter/responsible-contact-quick-filter';

export const ImportOverviewFilter = () => (
    <>
        <ResponsibleQuickContactFilter
            allText={<FormattedMessage id="app.imports.displayAll" />}
            ownText={<FormattedMessage id="app.imports.displayOwn" />}
        />
        <FilterModal>
            <DateRangeFilter fromField={'createdAtFrom'} untilField={'createdAtUntil'} />
            <ResponsibleContactFilter />
            <ImportStatusFilter />
            <LegacySupplierFilter />
        </FilterModal>
        <SearchFilter />
    </>
);
